import { Box, BoxProps } from '@jfs/ui-new'
import { FC, ReactChildren, ReactElement, ReactNode } from 'react';

export interface ViewProp extends BoxProps {
  ID?: string
  children?: ReactNode | ReactChildren | ReactElement | string
  style?: BoxProps | Array<BoxProps>
  show?: boolean
}

export const ModBox: FC<ViewProp> = ({ children, show = true, ...restprops }: ViewProp) => {
  if (!show) {
    return null
  }
  return (
    <Box testID="ViewTestId" {...restprops}>
      {children}
    </Box>
  )
}
